import React, { useEffect, useState } from "react";
import "./style.scss";
import clicks from "../../../assets/icons/clicks.svg";
import pushedLeds from "../../../assets/icons/purchased.svg";
import conversion from "../../../assets/icons/conversion.svg";
import profit from "../../../assets/icons/commission.svg";
import currentCommissions from "../../../assets/icons/balanceIcon.svg";
import approvedCommissions from "../../../assets/icons/approved-commissions.svg";

import InfoBox from "../../../reusableComponents/InfoBox";
import PushLeads from "./PushLeads";
import OverviewTable from "./OverviewTable";
import { useSelector } from "react-redux";
import axios from "axios";
import { baseUrl } from "../../../utils/apis";
import LoaderOverlay from "../../../reusableComponents/Loader";
import { formatNumberWithoutDecimal, formatUSD } from "../../../utils/helpers/string";

function Overview() {
  const idToken = useSelector((state) => state.auth.idToken);
  const [codeList, setCodeList] = useState({});
  const pushLeadData = codeList?.click_stats || [];
  const [isLoading, setIsLoading] = useState(false);

  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getData = async () => {
    setIsLoading(true);
    let config = {
      headers: {
        Authorization: "Bearer " + idToken,
      },
      params: {
        ...(selectedBrand?.brand === "crypto_edge" ? { crypto: true } : {}),
      },
    };
    axios
      .get(`${baseUrl}/affiliates/affiliate-stats/`, config)
      .then((res) => {
        setCodeList(res?.data || []);
        setIsLoading(false);
      })
      .catch((err) => { });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading]);
  const allClicks = codeList?.click_stats?.reduce((totalClicks, currentItem) => totalClicks + currentItem.clicks, 0);

  return (
    <div className="overview">
      {isLoading && <LoaderOverlay />}
      {/* <h4>Overview</h4> */}
      <div className="grid_container">
        <div className="column column-70">
          <div className="row-1">
            <div className="infobox_col1_container infobox-flex-row">
              <InfoBox
                title="Clicks"
                value={formatNumberWithoutDecimal(allClicks)}
                icon={clicks}
              />

              <InfoBox
                title="Pushed Leads"
                value={formatNumberWithoutDecimal(codeList?.pushed_leads)}
                icon={pushedLeds}
              />

              <InfoBox
                title="Lifetime Commissions"
                value={formatUSD(codeList?.commission_amount)}
                icon={profit}
              />

              <InfoBox
                title="Conversions "
                value={formatNumberWithoutDecimal(codeList?.conversions)}
                icon={conversion}
              />
              <InfoBox
                title="Approved Commissions"
                value={formatUSD(codeList?.approved_commissions)}
                icon={approvedCommissions}
              />
              <InfoBox
                title="Current Commissions"
                value={formatUSD(codeList?.current_commissions)}
                icon={currentCommissions}
              />
            </div>
          </div>
          <div
            className="box row-2 push_leads"
            style={{ display: codeList?.click_stats?.length > 0 ? "block" : "none" }}
          >
            {pushLeadData.length > 0 && <PushLeads codeList={pushLeadData || []} />}
          </div>
        </div>
        {/* <div className="column column-30">
          <div className="row-1">
            <div className="infobox_col2_container">
              {competitionsArr.map((info) => (
                <InfoBox
                  key={info.title}
                  title={info.title}
                  value={info.value}
                  img={info.img}
                  variant={3}
                />
              ))}
            </div>
          </div>
          <div className="box visitor row-2">
            <Visitor />
          </div>
        </div> */}
      </div>
      <div className="box table_container">
        <OverviewTable />
      </div>
    </div>
  );
}

export default Overview;
